module.exports = __webpack_public_path__ + "assets/fd2367e275d937da6d07df66cde5e1f4.mp3";